import React from 'react';
import PageGeneralMain from '../../PageGeneralMain';
import { Breadcrumbs } from '../../UIComponents/Breadcrumbs/Breadcrumbs';
import { Breadcrumb } from "../../UIComponents/Breadcrumbs/Breadcrumb";
import { Video } from '../../UIComponents/Video/Video';

import styles from './StageVideoPage.module.css';
import { BackButtonLink } from '../../UIComponents/BackButtonLink/BackButtonLink';

interface StageVideoPageProps {
    title: string;
    src: string;
    /* breadcrumbs: Breadcrumb[]; */
}

export const StageVideoPage = ({ title, src, /* breadcrumbs */ }: StageVideoPageProps) => {
    return (
        <div>
            <img alt="" className={styles['background-image']} src='https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/images-ui/alphabet_planet_ui_page_stage_video.svg' />
            {/* <Breadcrumbs breadcrumbs={breadcrumbs} currentPageTitle={title} pushContentDown /> */}
            <PageGeneralMain>
                <BackButtonLink title={"Gå tilbake"} />
                <div className={styles['video-wrapper']}>
                <h1 className={styles['page-title']}>{title}</h1>
                    <Video src={src} />
                </div>
            </PageGeneralMain>
        </div>
    );
};